module.exports = __webpack_public_path__ + "public/images/Illustration_Star_200x200-Color.6b01f4743a546508be2bcbb274ecd1e0.png";